export const enlace_formulario_institucion =
  "https://docs.google.com/forms/d/e/1FAIpQLSelU28Aqq7uFCOihnrcyQx1LQ2oaYYAheCiC0HdM6F4ryTNeQ/viewform?usp=sf_link";
export const enlace_formulario_investigador =
  "https://docs.google.com/forms/d/e/1FAIpQLSdbE905lXXaZyRWLOG9QcRPdlva_pvtcvrQNs1MGSNS_QUdQw/viewform?usp=sf_link";
export const enlace_formulario_protocolo =
  "https://docs.google.com/forms/d/e/1FAIpQLSfEa8FSV92Vf6RtfdjFakWR8YnrRo6R9TRCry3UF_NK4np_JQ/viewform?usp=sf_link";
